import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { taxAssumptionsSearchSchema } from '@/hooks/queries/crt/useTaxAssumptions'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import TaxAssumptionsDataTable from './-components/TaxAssumptionsDataTable'
import { CreateTaxAssumptionDialog } from './-components/CreateTaxAssumptionDialog'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/tax-assumptions/')({
  component: RouteComponent,
  validateSearch: (search) => taxAssumptionsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('taxAssumptions.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_pe_tax_assumptions_create']}>
          <CreateTaxAssumptionDialog />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('taxAssumptions.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <TaxAssumptionsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
